import {Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import Compressor from 'compressorjs';
import {FormService} from "../../services/form.service";
import {FormImage} from "../../domain/meta/form-image";

@Component({
    selector: 'image-picker-dialog',
    templateUrl: './image-picker-dialog.component.html',
    styleUrls: ["./image-picker-dialog.component.scss"]
})
export class ImagePickerDialog {

    photo: FormImage;
    images: FormImage[];
    imageDeleted = false;
    constructor(
        public dialogRef: MatDialogRef<ImagePickerDialog>,
        private formService: FormService,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit(){
        this.formService.getLastImages().subscribe((images: FormImage[]) => {
            this.images = images;
        });
        this.photo = this.data.image;
    }

    select(image: FormImage){
        this.photo = image;
    }

    remove(){
        this.photo = new FormImage({data: null});
        this.imageDeleted = true;
    }

    close(): void {
        this.dialogRef.close(null);
    }

    confirm(): void {
        this.formService.addFormImageToCache(this.photo)
        this.dialogRef.close(this.photo);
    }

    onPhotoUpload(event) {
        const reader = new FileReader();
        const file = event.target.files[0];

        new Compressor(file, {
            quality: 0.8,
            maxWidth: 300,
            maxHeight: 300,
            success: (result) => {
                reader.readAsDataURL(result);
                reader.onload = () => {
                    this.photo = new FormImage({data: reader.result.toString()});
                }
            },
            error: (err) => {
                console.log(err.message);
            },
        });

    }

}



// WEBPACK FOOTER //
// ./src/app/forms/components/image-picker-dialog/image-picker-dialog.component.ts